module.exports = __webpack_public_path__ + "static/media/bespoke-events.6815df4d.jpg";